import * as React from 'react';

import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';

import DeleteIcon from '@material-ui/icons/Delete';
import Add from '@material-ui/icons/AddBox';
import FileCopy from '@material-ui/icons/FileCopy';

import styles from './Widgets.module.styl';
import { toast } from 'react-toastify';

class Widgets extends React.Component<any, any> {
  public render() {
    const { input, meta, title } = this.props;

    return (
      <div className={styles.root}>
        <span className={styles.title}>{title}</span>
        {Array.isArray(input.value) &&
          input.value.map((value: any, index: number) => {
            const onChangeName = (e: any) => this.onChange(index, 'name', e);
            const onChangeCode = (e: any) => this.onChange(index, 'code', e);
            const ondDeleteWidget = () => this.onDelete(index);
            const onCopyWidget = () => this.onCopyWidget(index);
            return (
              <div className={styles.widget} key={index}>
                <div className={styles.input}>
                  <TextField
                    id={`outlined-with-placeholder${input.name}`}
                    label="Name"
                    placeholder="Name"
                    margin="normal"
                    onChange={onChangeName}
                    variant="outlined"
                    fullWidth={true}
                    value={input.value[index].name}
                    autoComplete="off"
                    error={Boolean(meta.touched && meta.error?.[index]?.name)}
                  />
                  {meta.touched && meta.error?.[index]?.name && (
                    <span className={styles.error}>
                      {meta.error[index].name}
                    </span>
                  )}
                </div>
                <div className={styles.input}>
                  <TextField
                    id={`outlined-with-placeholder${input.name}`}
                    label="Code"
                    placeholder="Code"
                    margin="normal"
                    onChange={onChangeCode}
                    variant="outlined"
                    fullWidth={true}
                    value={input.value[index].code}
                    autoComplete="off"
                    error={Boolean(meta.touched && meta.error?.[index]?.code)}
                  />
                  {meta.touched && meta.error?.[index]?.code && (
                    <span className={styles.error}>
                      {meta.error[index].code}
                    </span>
                  )}
                </div>
                <IconButton
                  className={styles.button}
                  aria-label="Copy"
                  onClick={onCopyWidget}
                >
                  <FileCopy />
                </IconButton>
                <IconButton
                  className={styles.button}
                  aria-label="Delete"
                  onClick={ondDeleteWidget}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            );
          })}
        <IconButton
          className={styles.add}
          aria-label="Add"
          onClick={this.onAddWidget}
          title="Add a widget"
        >
          <Add />
        </IconButton>
      </div>
    );
  }

  private readonly onDelete = (index: number) => {
    const values = Array.from(this.props.input.value) as any;
    values.splice(index, 1);
    this.props.input.onChange(values);
  };

  private readonly onChange = (index: number, value: string, e: any) => {
    const values = Array.from(this.props.input.value) as any;

    if (value === 'name') {
      values[index][value] = e.target.value
        .replace(/[^A-Z]/gi, '')
        .toUpperCase();
    } else {
      values[index][value] = e.target.value.trim();
    }

    this.props.input.onChange(values);
  };

  private readonly onAddWidget = () => {
    const values = Array.from(this.props.input.value) as any;

    values.push({
      name: '',
      code: '',
    });

    this.props.input.onChange(values);
  };

  private readonly onCopyWidget = (index: number) => {
    const values = this.props.input.value;

    if (!values[index]) {
      return;
    }

    const name = values[index].name;

    if (!name) {
      return;
    }

    const el = document.createElement('textarea');
    el.value = `<WIDGET:${name}>`;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    toast.success('Copied!');
  };
}

export { Widgets };
